import { faCalendar, faShield } from '@fortawesome/pro-regular-svg-icons'

import { Icon } from '@flecto/ui'
import { type FilterField } from '@flecto/ui/@shared/Filters/components/multi-select/filterTypeConfig'

export function useInsuranceFilterFields() {
  const insuranceFilterFields: FilterField[] = [
    {
      key: 'policy-status',
      type: 'policy-status',
      label: 'accordion.labels.policyStatus',
      icon: <Icon icon={faShield} />,
    },
    {
      key: 'start_at',
      type: 'date-time',
      label: 'accordion.labels.startDate',
      icon: <Icon icon={faCalendar} />,
    },
    {
      key: 'end_at',
      type: 'date-time',
      label: 'accordion.labels.endDate',
      icon: <Icon icon={faCalendar} />,
    },
    {
      key: 'policy-type',
      type: 'policy-type',
      label: 'accordion.labels.policyType',
      icon: <Icon icon={faShield} />,
    },
  ]

  return insuranceFilterFields
}
